import loadConfig from "@Web3WalletConfig/config.json";
import store from "@/store";

import { createAppKit } from "@reown/appkit";
import * as networkList from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { getBalance, getAccount, signMessage, disconnect, createStorage, reconnect, http, createConfig, readContract, simulateContract, writeContract, waitForTransactionReceipt } from "@wagmi/core";
import getNetworkIcon from "./networkIcons";
import { injected } from "@wagmi/connectors";
import fmt from "@utils/formatter";
import Web3 from "web3";

function setNetChain() {
  let netInfos = {};
  let networks = [];
  for (const key in networkList) {
    loadConfig.netIdList.map((itm) => {
      if (networkList[key].id === itm) {
        const netItem = networkList[key];
        networks.push(networkList[key]);
        netInfos[`${netItem.id}`] = {
          rpc: netItem.rpcUrls?.default?.http,
          decimals: netItem.nativeCurrency.decimals,
          name: netItem.nativeCurrency.name,
          symbol: netItem.nativeCurrency.symbol,
          url: netItem.blockExplorers.default.url,
          id: netItem.id,
          icon: getNetworkIcon(netItem.id),
          explorer: netItem.blockExplorers.default,
        };
      }
    });
  }
  return { netInfos, networks };
}

var Web3Wallet = {
  isConnect: null, //是否已经连接上钱包 String 'connecting' 尝试建立连接  | 'reconnecting' 尝试重新建立与一个或多个连接器的连接 | 'connected' 至少有一个连接器已连接 | 'disconnected' 未连接至任何连接器
  address: null, //钱包地址 Sring
  modal: null, //模态框对象 Object
  unWatchAccount: null, //取消订阅账户更改事件函数 function
  isinit: false,
  wagmiConfig: null,
  openType: "Connect", //唤醒modal视图UI类型 String  'Connect' 默认视图 | 'Account' 用户资料 |  'AllWallets' 显示所有可用钱包的列表 | 'Networks' 可用网络列表
  connector: null, //连接器
  netInfos: {},
  networks: {},
  balance: null, //ETHER余额
  netId: 0, //当前网络id
  symbol: "", //当前币符号
  icon: "", //当前币图片
  dec: "", //当前精度
  explorer: "", //当前网络浏览器url
  eventWeb3: null,
  web3: null,
  etherUSD: null, //美元价格
  wagmiAdapter: null,
  getAccountInfoTime: null,
  maxUint256: fmt.fmt_floatDec("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", "bigInt"),
  web3FucSetTimer: null,
  web3WindQueryTimer: null,
  web3WindQueryFnTimer: null,
  isDisConnect: false,
  createFee: {
    //发币费用
    value: null,
    label: null,
  },
  feeRate: null, //默认是1表示平台收 1%手续费， 要从合约取最新的
  createFeeLabel: null,
  time: 9000, //链上数据需要定时轮询时间间隔
  errorTime: 3000, //当链上数据获取异常时, 再次尝试获取间隔
  //基础链上数据查询(针对无连接查询)
  web3BasicQueryFn: async function () {
    const [createFee, feeRate] = await Promise.all([
      Web3Wallet.contract("marspump", "marsPumpAddr").call("createFee", []), //发币费用
      Web3Wallet.contract("marspump", "marsPumpAddr").call("feeRate", []),
    ]);
    Web3Wallet.createFee.value = createFee;
    Web3Wallet.createFee.label = fmt.fmt_floatDec(createFee);
    Web3Wallet.feeRate = parseInt(feeRate) / 100;
  },
  //基础链上数据查询(针对连接钱包后的一些数据查询)
  web3WindQueryFn: async function () {
    return new Promise(async (resolve, reject) => {
      try {
        const web3Info = await Promise.all([
          Web3Wallet.address ? Web3Wallet.contract("marspump", "marsPumpAddr").call("poolStarted", []) : Promise.resolve(null), //矿池状态
        ]);
        store.commit("user/setWeb3Data", {
          poolStarted: web3Info[0],
        });
      } catch (err) {
        console.log("store.user.web3Data.poolStartedstore.user.web3Data.poolStarted", err);
      }
      async function fn() {
        try {
          console.log("location========",/token/.test(location.href));
          clearTimeout(Web3Wallet.web3WindQueryTimer);
          const web3Queries = [
            Promise.resolve(null), //我的ether余额
            Web3Wallet.address && (/reward/.test(location.href) ||/referral/.test(location.href)) ? Web3Wallet.contract("powerpool", "powerPoolAddr").call("userPower", [Web3Wallet.address]) : Promise.resolve(null), //我的算力
            Web3Wallet.address&& /referral/.test(location.href) ? Web3Wallet.contract("powerpool", "powerPoolAddr").call("userRefPower", [Web3Wallet.address]) : Promise.resolve(null), //我的邀请算力
            Web3Wallet.address&& /reward/.test(location.href) ? Web3Wallet.contract("marspump", "marsPumpAddr").call("pending", [Web3Wallet.address]) : Promise.resolve([0, 0]), //矿池-我的待领取奖励
            Web3Wallet.address&& /reward/.test(location.href) ? Web3Wallet.contract("tokenpool", "tokenPoolAddr").call("userPower", [Web3Wallet.address]) : Promise.resolve(null), //我的质押
            Web3Wallet.address&& /reward/.test(location.href) ? Web3Wallet.contract("token", "marspAddr").call("balanceOf", [Web3Wallet.address]) : Promise.resolve(null), //我的Masp余额
            /reward/.test(location.href) && Web3Wallet.contract("powerpool", "powerPoolAddr").call("totalPower", []), //平台总算力
            /reward/.test(location.href) && Web3Wallet.contract("tokenpool", "tokenPoolAddr").call("totalPower", []), //平台总质押
            /reward/.test(location.href) && Web3Wallet.contract("tokenpool", "tokenPoolAddr").call("rewPerBlock", []), //APR
          ];
          const web3Info = await Promise.all(web3Queries);

          const rewPerBlock = web3Info[8];
          const blockPerDay = Web3Wallet.netId ? loadConfig.blockPerDay[Web3Wallet.netId] : 0;
          const platformTotalStake = web3Info[7];
          const apr = _v.bigNumber(rewPerBlock).times(blockPerDay).times(365).div(platformTotalStake).times(100).toFixed(10);

          store.commit("user/setWeb3Data", {
            // balance: web3Info[0],
            myPower: web3Info[1],
            myRefPower: web3Info[2],
            pending: web3Info[3] ? web3Info[3][0] + web3Info[3][1] : null,
            myStake: web3Info[4],
            myMaspBalance: web3Info[5],
            platformTotalPower: web3Info[6],
            platformTotalStake: web3Info[7],
            apr,
          });
          Web3Wallet.balance = web3Info[0];
          Web3Wallet.web3WindQueryFnTimer = setTimeout(fn, Web3Wallet.time);
          resolve();
        } catch (err) {
          console.log(err);
          Web3Wallet.web3WindQueryTimer = setTimeout(() => fn, Web3Wallet.errorTime);
        }
      }
      fn();
    });
  },
  getBalance: async function (addr) {
    // const balance = await getBalance(Web3Wallet.wagmiConfig, { address: addr, chainId: Web3Wallet.netId });
    // return balance;
    const _balance = await Web3Wallet.web3.eth.getBalance(addr);
    const balance = {
      formatted: _v.fmt_floatDec(_balance),
      value: _balance,
    };
    return balance;
  },

  //初始化web3模态框
  initWeb3Modal: function () {
    return new Promise(async (resolve, reject) => {
      Web3Wallet.isinit = false;
      Web3Wallet.flag = true;
      const { netInfos, networks } = setNetChain();
      Web3Wallet.netInfos = netInfos;
      Web3Wallet.networks = networks;

      Web3Wallet.wagmiAdapter = new WagmiAdapter({
        projectId: loadConfig.web3projectId,
        networks,
        pendingTransactionsFilter: {
          enable: true,
          pollingInterval: 60_000,
        },
      });
      const modal = createAppKit({
        adapters: [Web3Wallet.wagmiAdapter],
        networks,
        metadata: loadConfig.web3metadata,
        projectId: loadConfig.web3projectId,

        themeVariables: {
          "--w3m-color-mix": "#1f1f1f",
          "--w3m-font-family": "pFont",
          "--w3m-accent": "#ffe501",
          "--w3m-color-mix-strength": 40,
        },
        features: {
          email: false, // default to true
          socials: false,
        },
      });
      Web3Wallet.modal = modal;
      Web3Wallet.wagmiConfig = Web3Wallet.wagmiAdapter.wagmiConfig;
      Web3Wallet.web3FucSet();
      // 监听账号变化
      Web3Wallet.modal.subscribeAccount(async (event) => {
        // console.log("event=======", event.status, Web3Wallet.wagmiConfig.state.status);
        if (event.status === "connected") {
          await Web3Wallet?.getAccount(event);
        }
        resolve();
      });

      let connectors = Web3Wallet.wagmiConfig?.connectors;
      const connectorId = localStorage.getItem("@appkit/connected_connector") || localStorage.getItem("wagmi.recentConnectorId");

      if (connectorId) {
        const reId = connectorId.replace(/"/g, "");
        for (const key in connectors) {
          const item = connectors[key];
          if (item.id === reId) {
            console.log("item====", item);
            const accs = await item.getAccounts();
            item.onConnect((event) => {});
            console.log("accs", accs, Web3Wallet.wagmiConfig);
          }
        }
      }

      //监听web3模态窗口状态
      Web3Wallet.modal.subscribeState((newState) => {
        if (!newState.open) {
          store.commit("wallet/setBtnWalletLoading", false);
        } else {
          store.commit("wallet/setBtnWalletLoading", true);
        }
      });
    });
  },
  //获取账户
  getAccount: async function (event) {
    try {
      Web3Wallet.netId = null;
      Web3Wallet.address = null;
      Web3Wallet.isConnect = null;
      Web3Wallet.connector = null;
      Web3Wallet.openType = "Connect";
      if (!Web3Wallet.wagmiConfig) {
        return;
      }
      const account = getAccount(Web3Wallet.wagmiConfig);
      console.log("account========", account, account.status, event.status, Web3Wallet.wagmiConfig.state.status, Web3Wallet.wagmiConfig);
      if (account.status === "connected" && Web3Wallet.wagmiConfig.state.status === "connected" && !Web3Wallet.isDisConnect) {
        const chainId = Web3Wallet.wagmiConfig.state.chainId;
        const current = Web3Wallet.wagmiConfig.state.current;
        const connections = Web3Wallet.wagmiConfig.state.connections;
        // console.log("connections", connections);
        connections.forEach(function (v, k) {
          if (k == current) {
            v.chainId = chainId;
            // Web3Wallet.windowEthereumConnect(v.connector);
          } else {
            connections.delete(k);
          }
        });
        Web3Wallet.netId = chainId;
        Web3Wallet.symbol = Web3Wallet.netInfos[chainId].symbol;
        Web3Wallet.dec = Web3Wallet.netInfos[chainId].decimals;
        Web3Wallet.icon = Web3Wallet.netInfos[chainId].icon;
        Web3Wallet.explorer = Web3Wallet.netInfos[chainId].explorer;
        Web3Wallet.address = account.address;
        Web3Wallet.isConnect = account.status;
        Web3Wallet.openType = "Account";
        Web3Wallet.modal.close();
        Web3Wallet.connector = account.connector;
        localStorage.setItem("v.wallet.connected", true);
        store.commit("wallet/setBtnWalletLoading", false);
        Web3Wallet.getAccountInfoTime = new Date().getTime();
        console.log("Web3Wallet.getAccountInfoTime", Web3Wallet.getAccountInfoTime);
        console.log("Web3Wallet.address", Web3Wallet.address);
        store.commit("wallet/setWeb3Info", { isConnect: Web3Wallet.isConnect, address: Web3Wallet.address, netId: Web3Wallet.netId });
      } else if (Web3Wallet.wagmiConfig.state.status === "disconnected") {
      } else if (account?.connector?.hasOwnProperty("disconnect")) {
        //退出钱包时
        localStorage;
      }
    } catch (err) {
      console.log("err===", err);
    }
  },
  web3FucSet: async function () {
    const infoTime = Web3Wallet.getAccountInfoTime;
    Web3Wallet.web3FucSetTimer = setTimeout(async () => {
      const nowTime = new Date().getTime();
      if (nowTime > infoTime + 2000) {
        Web3Wallet.web3FucSet();
        return;
      }
      clearTimeout(Web3Wallet.web3FucSetTimer);
      clearTimeout(Web3Wallet.web3WindQueryFnTimer);
      await Web3Wallet.web3BasicQueryFn();
      await Web3Wallet.web3WindQueryFn();
    }, 1000);
  },
  //错误收集
  colError: function (err) {
    // console.error("=========", err, err.shortMessage);
  },
  //签名操作
  signMessage: async function (sign) {
    if (!Web3Wallet.isinit) return;
    return new Promise(async (resolve, reject) => {
      try {
        console.log("signMessage sign info:", sign);
        const signature = await signMessage(Web3Wallet.wagmiConfig, {
          message: sign,
        });
        console.log("signature success");
        resolve(signature);
      } catch (err) {
        Web3Wallet.colError(err);
      }
    });
  },
  //断开链接
  disConnect: async function () {
    // if (!Web3Wallet.isinit) return;
    // if (!Web3Wallet.connector) return;
    try {
      Web3Wallet.doConnectJsonRpc();
      localStorage.removeItem("v.wallet.connected");
      Web3Wallet.modal.adapter?.connectionControllerClient?.disconnect();
      Web3Wallet.netId = null;
      Web3Wallet.address = null;
      Web3Wallet.isConnect = null;
      Web3Wallet.connector = null;
      Web3Wallet.openType = "Connect";
      Web3Wallet.connectJsonRpc();
      Web3Wallet.isDisConnect = true;

      store.commit("wallet/setWeb3Info", { isConnect: Web3Wallet.isConnect, address: Web3Wallet.address, netId: Web3Wallet.netId });
    } catch (err) {
      Web3Wallet.colError(err);
      resolve();
    }
  },
  //合约交互
  contract: function (contractAbiFileName, contractAddr) {
    const contractAbi = require(`@web3Contracts/${contractAbiFileName}.json`);
    const contractInstant = { send: null, call: null };
    const addrReg = /^0x/;
    contractInstant.send = function (functionName, params = [], value = 0) {
      return new Promise(async (resolve, reject) => {
        if (addrReg.test(_v[contractAddr]) || addrReg.test(contractAddr)) {
          try {
            const _params = {
              address: _v[contractAddr] || contractAddr,
              abi: contractAbi,
              functionName,
              args: params,
              value: value,
              chainId: Web3Wallet.netId,
            };
            console.log("contract send params", _params);
            const { request } = await simulateContract(Web3Wallet.wagmiConfig, _params);
            console.log("contract send request: ", request);
            const hash = await writeContract(Web3Wallet.wagmiConfig, request);
            console.log("contract send hash: ", hash);
            let result = await waitForTransactionReceipt(Web3Wallet.wagmiConfig, { hash });
            console.log("contract send success: ", result);
            resolve(result);
          } catch (err) {
            Web3Wallet.colError(err);
            // console.log("contractInstant send Error: ", err);
            reject(err);
          }
        } else {
          resolve(null);
        }
      });
    };
    contractInstant.call = function (functionName, params = []) {
      return new Promise(async (resolve, reject) => {
        if (addrReg.test(_v[contractAddr]) || addrReg.test(contractAddr)) {
          // try {
          //   const config = {
          //     address: _v[contractAddr] || contractAddr,
          //     abi: contractAbi,
          //     functionName,
          //     args: params,
          //   };
          //   let result = await readContract(Web3Wallet.wagmiConfig, config);
          //   resolve(result);
          // } catch (err) {
          //   Web3Wallet.colError(err);
          //   console.log("contractInstant call Error: ", functionName, err);

          //   reject(err);
          // }
          try {
            const addr = _v[contractAddr] || contractAddr;
            const contractCall = new Web3Wallet.web3.eth.Contract(contractAbi, addr);
            let result = null;
            if (params && params.length > 0) {
              result = await contractCall.methods[functionName](...params).call();
            } else {
              result = await contractCall.methods[functionName]().call();
            }
            resolve(result);
          } catch (err) {
            console.log(`err call (funcName ${functionName}):`, err.code, "params:", params, err);
            resolve();
          }
        } else {
          resolve(null);
        }
      });
    };
    return contractInstant;
  },
  //钱包连接
  connect: async function () {
    store.commit("wallet/setBtnWalletLoading", true);
    const walletConnected = localStorage.getItem("v.wallet.connected");
    if (!walletConnected && Web3Wallet) {
      await Web3Wallet.initWeb3Modal();
    }
    Web3Wallet.isDisConnect = false;
    Web3Wallet.modal.open({ view: Web3Wallet.openType });
  },
  windowEthereumConnect: async (connector) => {
    Web3Wallet.web3 = new Web3(connector);
    // if (typeof connector === "string") {
    //   //rpc
    // } else {
    //   //已连接的ethereum 对象 注入web3
    //   const provider = await connector?.getProvider();
    //   if (!provider) return;
    //   Web3Wallet.web3 = new Web3(provider);
    //   const accounts = await Web3Wallet.web3.eth.getAccounts();
    //   console.log("Web3Wallet.web36666666666666", accounts, Web3Wallet.web3);
    // }
  },
  //未链接钱包时获取链上数据方法
  connectJsonRpc: async () => {
    const { netInfos, networks } = setNetChain();
    const rpc = store.state.user.rpc;
    if (rpc) {
      await Web3Wallet.windowEthereumConnect(rpc);
    } else {
      const _netIdList = loadConfig.netIdList;
      let _rpc = null;
      networks.map((item) => {
        _netIdList.map((itm) => {
          if (item.id === itm) {
            _rpc = item.rpcUrls.default.http[0];
          }
        });
      });

      await Web3Wallet.windowEthereumConnect(_rpc);
    }

    Web3Wallet.networks = networks;
    Web3Wallet.netInfos = netInfos;
    // Web3Wallet.wagmiConfig = config;
    Web3Wallet.netId = loadConfig.netIdList[0];
    Web3Wallet.symbol = Web3Wallet.netInfos[Web3Wallet.netId].symbol;
    Web3Wallet.dec = Web3Wallet.netInfos[Web3Wallet.netId].decimals;
    Web3Wallet.icon = Web3Wallet.netInfos[Web3Wallet.netId].icon;
    Web3Wallet.explorer = Web3Wallet.netInfos[Web3Wallet.netId].explorer;
    Web3Wallet.getAccountInfoTime = new Date().getTime();
    store.commit("wallet/setWeb3Info", { netId: Web3Wallet.netId });
  },
  doConnectJsonRpc: async function () {
    await disconnect(Web3Wallet.wagmiConfig, injected);
  },
};
export default Web3Wallet;
